import React from 'react';
import PropTypes from 'prop-types';
import * as d3 from 'd3';
import styled from 'styled-components';
import {
  DataProvider,
  ChartContainer,
  LineChart,
  ContextChart,
} from '@cognite/griff-react';

const Wrapper = styled.div`
  .context-brush .handle {
    width: 6px;
    fill: rgb(0, 72, 125);
  }
`;

const ChartComponent = ({
  colors,
  loader,
  margin,
  width,
  height,
  range,
  updateLegendValues,
  tags,
  hiddenSeries,
  axisConfig,
  annotations,
  onClickAnnotation,
  strokeWidths,
}) => {
  const staticDomain = {};
  Object.keys(axisConfig).forEach(key => {
    const c = axisConfig[key];
    if (c.static) {
      staticDomain[key] = [c.minValue || 0, c.maxValue || 0];
    }
  });
  const chartConfig = {
    pointsPerSerie: 500,
    yAxis: { mode: 'every', width: 50, accessor: d => d.average, staticDomain },
    xAxis: {
      accessor: d => d.timestamp,
      calculateDomain: data => d3.extent(data, d => d.timestamp),
    },
    baseDomain: [+range.start, +range.end],
  };
  return (
    <Wrapper>
      <DataProvider
        colors={colors}
        width={width}
        height={height}
        loader={loader}
        margin={margin}
        config={chartConfig}
        hiddenSeries={hiddenSeries}
        annotations={annotations}
        strokeWidths={strokeWidths}
      >
        <ChartContainer>
          <LineChart
            crosshairs
            heightPct={0.8}
            onMouseMove={data => {
              const { points } = data;
              if (points) {
                const legendValues = {};
                tags.forEach((t, i) => {
                  legendValues[t.value] = points[i];
                  updateLegendValues(legendValues);
                });
              }
            }}
            onClickAnnotation={onClickAnnotation}
          />
          <ContextChart heightPct={0.08} margin={{ top: 0.05 }} />
        </ChartContainer>
      </DataProvider>
    </Wrapper>
  );
};

ChartComponent.propTypes = {
  colors: PropTypes.object.isRequired,
  loader: PropTypes.func.isRequired,
  margin: PropTypes.object,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  strokeWidths: PropTypes.object,
};

ChartComponent.defaultProps = {
  margin: { right: 0, top: 0, left: 0, bottom: 0 },
};

export default ChartComponent;



// WEBPACK FOOTER //
// ./src/components/ChartView/ChartComponent.js